import flatpickr from 'flatpickr'
import { Polish } from 'flatpickr/dist/l10n/pl.js'
import dayjs from 'dayjs'
import { setBseWidgetDate, today, tomorrow } from './set-bse-widget-date'

const locales = {
  pl: Polish,
  en: 'en',
}
const currentLang = document.documentElement.lang.substring(0, 2)

if (document.querySelector('#dateRangeStart')) {
  setBseWidgetDate()
}

let selectedDates = [today, tomorrow]
const bseWidgetFrame = document.querySelector('#bse-widget-frame')
const callWidgetBtns = document.querySelectorAll('.call-bse-widget')
const bseIframe = document.createElement('div')
bseIframe.className = 'bse-widget-frame-content'
bseWidgetFrame.appendChild(bseIframe)
const closeWidgetArr = document.querySelectorAll(
  '.bse-close, #bse-widget-frame'
)
const urlBase = ''
let urlRoom = `${
    !script_vars.engine_id ? '' : '?ob[' + script_vars.engine_id + ']'
}`

let languageSetting = 0;
const currentLanguage = document.documentElement.lang;

if (currentLanguage === 'pl-PL') {
  languageSetting = 1;
} else if (currentLanguage === 'en-GB') {
  languageSetting = 2;
}

// call widget function
const callWidget = () => {
  let url = `${urlBase + urlRoom}?start_date=${
    selectedDates[0].format('YYYY-MM-DD')
}&end_date=${selectedDates[1].format('YYYY-MM-DD')}&language=${languageSetting}&from_own_button=1`
  window.open(url)
  // document.querySelector('body').classList.add('block')
  // bseIframe.innerHTML = `<div class="bse-wrapper"><iframe src="${url}" frameborder="0"></iframe><div class="bse-close"></div></div>`
  // bseWidgetFrame.classList.add('!block')
}

// call widget listeners
callWidgetBtns.forEach((button) => {
  button.addEventListener('click', () => {
    if (button.dataset.engineId) {
      urlRoom = `?ob[${button.dataset.engineId}]`
      //callWidget(urlRoom)
    } else {
      //callWidget()
    }
  })
})

// close widget
closeWidgetArr.forEach((element, index) => {
  element.addEventListener('click', function (e) {
    bseWidgetFrame.classList.add('hide')
    document.querySelector('body').classList.remove('block')
    setTimeout(function () {
      bseWidgetFrame.classList.remove('!block')
      bseWidgetFrame.classList.remove('hide')
    }, 300)
  })
})

// create new flatpicker instance
document.addEventListener('DOMContentLoaded', () => {
  const flatpickrCallers = document.querySelectorAll('.flatpickr-caller')
  if (flatpickrCallers.length) {
    const engineWidgetWrapper = document.querySelector('.engine-widget')
    const fp = flatpickr('#flatpickr-input', {
      locale: locales[currentLang],
      dateFormat: 'd/m/Y',
      positionElement: engineWidgetWrapper,
      position: 'above center',
      mode: 'range',
      showMonths: 2,
      minDate: 'today',
      onChange: (dates) => {
        if (dates.length > 1) {
          selectedDates = [dayjs(dates[0]), dayjs(dates[1])]
          //callWidget()
          setBseWidgetDate(...selectedDates)
        }
      },
    })

    flatpickrCallers.forEach((caller) => {
      caller.addEventListener('click', () => {
        fp.open()
      })
    })
  }
})
